/* eslint-disable */ 
import React, { useState } from "react";
import { useFormik } from "formik";

import { Link } from "react-router-dom";
import { InvoiceLogo1 } from "../_components/Imagepath";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { emailrgx } from "../assets/constant";
import axios from "../api/axios";
import {  Apitoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const schema = yup.object({
  email: yup
    .string()
    .matches(emailrgx, "Email is required")
    .required("Email is required")
    .trim(),
  password: yup.string().min(6).max(6).required("Password is required").trim(),
});

const Login = (props) => {
  const [eye, seteye] = useState(true);
  const [backendErrors, setBackendErrors] = useState([]);
  const [backendSuccess, setBackendSuccess] = useState(false);

 
  
 
  const {
    values,
    errors,

    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      password: "",
      email: "",
    },
    onSubmit: (values, actions) => {
     
      axios
        .post("/login", values, { headers: { Apitoken: Apitoken } })
        .then((response) => {
          actions.setSubmitting(false);
          console.log(response.data);
          setBackendSuccess('')
          delete backendErrors['error'];
          if (response.data.code === 200) {
         
          
            let responsetoken = response.data.data.token;
            let auth_name = response.data.data.user.first_name;
            let role_id = response.data.data.user.role_id;
            let customer_id = response.data.data.user.customer_id;
            let auth_email = response.data.data.user.email;
            let auth_role = response.data.data.user.role.title;
            let firebase_token = response.data.data.user.firebase_token;
           // let auth_context = JSON.stringify(response.data.data.user.firebase_token);  ;
            let user_id = response.data.data.user.id;
             let menu_modules =    JSON.stringify(response.data.data.modules); 

             let profile_picture = response.data.data.user.profile_picture;
             let user_location = response.data.data.user.user_location;

             
            let season_id = response.data.data.season.id;
            let season_name = response.data.data.season.name;
            let season_start = response.data.data.season.start;
            let season_end = response.data.data.season.end;
           
             setBackendSuccess(response.data.message);
              toast.success(response.data.message);
            localStorage.setItem("isLoggedIn", true);
            localStorage.setItem("season_id", season_id);
            localStorage.setItem("season_name", season_name);
            localStorage.setItem("season_start", season_start);
            localStorage.setItem("season_end", season_end);
            localStorage.setItem("auth_token", responsetoken);
            localStorage.setItem("auth_id", user_id);
            localStorage.setItem("customer_id", customer_id);
            localStorage.setItem("role_id", role_id);
            localStorage.setItem("auth_name", auth_name);
            localStorage.setItem("auth_email", auth_email);
            localStorage.setItem("auth_role", auth_role);
            localStorage.setItem("firebase_token", firebase_token);
            localStorage.setItem("profile_image", profile_picture);
            localStorage.setItem("user_location", user_location);
            localStorage.setItem("menu_modules", menu_modules);

             localStorage.setItem("all_seasons", JSON.stringify(response.data.data.seasons));
            
            setTimeout(() => {
              // if(role_id === 3){
              //   window.location.href = "/customer/index";
              // }else{
                window.location.href = "/profile";
              // }
            }, 500);
          } 
          else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          actions.setSubmitting(false);
        });
    },
  });
  const onEyeClick = () => {
    seteye(!eye);
  };
  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  const isLoggedInVAr =  localStorage.getItem("auth_id");
 
  return (
    <><ToastContainer />
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <img
              className="img-fluid logo-dark mb-2"
              src={InvoiceLogo1}
              alt="Logo"
            />
            <div className="loginbox">
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>Login</h1>
                  <p className="account-subtitle">Access to our dashboard</p>
                  <div>
                    <form  onSubmit={handleSubmit}>
                      <div className="input-block mb-3 input_text">
                        <label className="form-control-label">
                          Email Address
                        </label>
                        {/* <Controller
                          name="email"
                          //control={control}
                          render={({ field: { value, onChange } }) => (
                            <input
                              className={`form-control  ${
                                errors?.email ? "error-input" : ""
                              }`}
                              type="text"
                              value={value}
                              onChange={onChange}
                              autoComplete="false"
                            />
                          )}
                        /> */}
                         <input
                          type="email"
                          name="email"
                          className={
                            errors.email
                              ? "form-input form-control input-error"
                              : "form-input form-control"
                          }
                          placeholder="Email"
                          value={values.email}
                          onChange={(e) => {
                            handleChange(e);
                            customHandleInput(e);
                          }}
                          onBlur={handleBlur}
                        />
                         

                         <small>
                            {backendErrors.email && (
                            <span className="form-error mt-1">
                              {backendErrors.email}
                            </span>
                          )}
                          </small>
                      </div>
                      <div className="input-block mb-3 input_text login-eye">
                        <label className="form-control-label">Password</label>
                        <input
                            type={eye ? "password" : "text"}
                            name="password"
                            className={
                              errors.password
                                ? "form-input form-control input-error"
                                : "form-input form-control"
                            }
                            placeholder="Password"
                            value={values.password}
                            onChange={(e) => {
                              handleChange(e);
                              customHandleInput(e);
                            }}
                            onBlur={handleBlur}
                          />
                        {/* <Controller
                          name="password"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <div className="pass-group">
                              <input
                                type={eye ? "password" : "text"}
                                className={`form-control  ${
                                  errors?.password ? "error-input" : ""
                                }`}
                                value={value}
                                onChange={onChange}
                                autoComplete="false"
                              />
                              <span
                                onClick={onEyeClick}
                                className={`fas toggle-password ${
                                  eye ? "fa-eye-slash" : "fa-eye"
                                }`}
                              />
                            </div>
                          )}
                        /> */}

                        <small className="error-validation">
                           {backendErrors.password && (
                            <span className="form-error mt-1">
                              {backendErrors.password}
                            </span>
                          )}

                        {backendErrors.error  && (
                          <span className="form-error mt-1">
                            {backendErrors.error}
                          </span>  )}
                            {backendSuccess && (
                          <span className="from-success mt-1">
                            {backendSuccess}
                          </span> )} 

                        </small>
                      </div>
                      <div className="input-block mb-3">
                        <div className="row">
                          <div className="col-6">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="cb1"
                              />
                              <label
                                className="custom-control-label ms-1"
                                htmlFor="cb1"
                              >
                                Remember me
                              </label>
                            </div>
                          </div>
                          
                          <div className="col-6 text-end">
                            <Link className="forgot-link" to="/forgot-password">
                              {" "}
                              Forgot Password ?{" "}
                            </Link>
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-lg btn-block w-100 btn-primary w-100"
                        type="submit"
                      >
                        Login
                      </button>
                    </form>
                    {/* <div className="login-or">
                      <span className="or-line" />
                      <span className="span-or">or</span>
                    </div> */}
                 
                    {/* <div className="social-login mb-3">
                      <span>Login with</span>
                      <Link to="#" className="facebook">
                        <i className="fab fa-facebook-f" />
                      </Link>
                      <Link to="#" className="google">
                        <i className="fab fa-google" />
                      </Link>
                    </div>
                    
                    <div className="text-center dont-have">
                      Don't have an account yet?{" "}
                      <Link to="/register">Register</Link>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Login;
